<div class="w-100 h-100 form">
  <h4 class="text-center">Editar Producto / Servicio</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-6">
      <div class="">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título de Producto / Servicio</mat-label>
          <input matInput placeholder="Título de Producto / Servicio" [(ngModel)]="this.productInfo.title" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
          <mat-hint>No uses un titulo ya existente en otro Producto o Servicio!</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6 d-flex align-items-center mb-4">
      <button mat-mini-fab aria-label="Add Link" class="save-button" matTooltip="Crear Link"
        (click)="createLinkFields()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="col-12">
      <div class="mb-3 max-height">
        <div *ngFor="let link of this.productInfo.productServicesItem, index as i">
          <div class="d-flex align-items-center">
            <h5 class="m-0 font-weight-bold">Link {{i + 1}}</h5>
          </div>
          <div class="d-flex ">
            <mat-form-field appearance="outline" class="w-100 me-4">
              <mat-label>Título de Link</mat-label>
              <input matInput placeholder="Título de Link" [(ngModel)]="link.item" required>
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>URL de link</mat-label>
              <input matInput placeholder="URL de Link" [(ngModel)]="link.url" required>
              <mat-error>Este campo es <b>Requerido</b></mat-error>
            </mat-form-field>
            <button class="mt-2" mat-icon-button (click)="deleteLinkField(i)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="mx-3 d-flex justify-content-center">
      </div>
    </div>
  </div>


  <div class="bottom-button">
    <p style="color: red; font-weight: bold;" *ngIf="checkExistingName()">
      Este nombre se encuentra actualmente en uso, usa uno diferente!
    </p>
    <button class="vs-btn-blue" (click)="sendData()" [disabled]="!validateEmptyFields() || checkExistingName()">
      Guardar
    </button>
  </div>

</div>
